import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, firstValueFrom } from 'rxjs';
import { EventModel } from '../models/event.model';
import { ApiService } from '../../shared/services/core/api.service';
import { EventsWithTicketsViewModel } from '../models/events-with-tickets-view.model';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor(private api: ApiService) {}

  private _eventWithTickets: ReplaySubject<EventsWithTicketsViewModel[]> = new ReplaySubject<EventsWithTicketsViewModel[]>(1);
  eventWithTickets$: Observable<EventsWithTicketsViewModel[]> = this._eventWithTickets.asObservable();
  set eventWithTickets(eventWithTickets: EventsWithTicketsViewModel[]) {
    this._eventWithTickets.next(eventWithTickets);
  }

  selectedGame: EventsWithTicketsViewModel;

  public getEvents(): Observable<EventModel[]> {
    return this.api.get<EventModel>('events?startDate=' + formatDate(Date.now(), 'yyyyMMdd', 'en-GB'));
  }

  public getCurrentOrNext(): Observable<EventModel> {
    return this.api.getAnySingle<EventModel>('events/current?dataSource=club');
  }

  async getEventsWithTickets() {
    let result = await firstValueFrom(this.api.get<EventsWithTicketsViewModel>('events/eventsWithTickets'));
    this.eventWithTickets = result;
    return result;
  }
}
